export default __webpack_public_path__ + "static/media/redoute.0e9d39e3.png";